import React from "react";
import { Header } from "./components";
import SubNav from "./components/SubNav";

// Цэс дээд талд (зүүн цэс хэрэглэхгүй) + бүлгийн дэд мөр
const Layout = ({ children }) => (
  <div id="layout" className="layout-top">
    <Header />
    <main><SubNav />{children}</main>
  </div>
);

export default Layout;
